import { useProductData } from "../../../../../../../../context/context/product-context-hooks.js";
import { useSolutionsEcommContext } from "../../../../../context/modules/EcommContent/SolutionsEcommContent/context/SolutionsEcommContext.js";
const useGetSolutionsLoyaltyPoints = () => {
  const {
    displayPrice: { loyaltyPoints }
  } = useProductData();
  const { state } = useSolutionsEcommContext();
  if (!loyaltyPoints) {
    return void 0;
  }
  return loyaltyPoints * state.configurations.quantity;
};
export {
  useGetSolutionsLoyaltyPoints
};
//# sourceMappingURL=use-get-solutions-loyalty-points.js.map
